/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const CodeIcon = ({ width = 24, height = 24, hidden = false, title = 'Code' } = {}):
  | string
  | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    width="${width}"
    height="${height}"
    viewBox="0 0 20 20"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M5.5,14.5c-.19238,0-.38379-.07324-.53027-.21973l-3.75-3.75c-.29297-.29297-.29297-.76758,0-1.06055l3.75-3.75c.29297-.29297.76758-.29297,1.06055,0s.29297.76758,0,1.06055l-3.21973,3.21973,3.21973,3.21973c.29297.29297.29297.76758,0,1.06055-.14648.14648-.33789.21973-.53027.21973Z"
      fill="currentColor"
    />
    <path
      d="M14.5,14.5c-.19238,0-.38379-.07324-.53027-.21973-.29297-.29297-.29297-.76758,0-1.06055l3.21973-3.21973-3.21973-3.21973c-.29297-.29297-.29297-.76758,0-1.06055s.76758-.29297,1.06055,0l3.75,3.75c.29297.29297.29297.76758,0,1.06055l-3.75,3.75c-.14648.14648-.33789.21973-.53027.21973Z"
      fill="currentColor"
    />
    <path
      d="M8.22852,18c-.05859,0-.11816-.00684-.17676-.02051-.40332-.09766-.65039-.50293-.55371-.90527l3.5-14.5c.09766-.40332.50977-.64551.90527-.55371.40332.09766.65039.50293.55371.90527l-3.5,14.5c-.08301.34375-.39062.57422-.72852.57422Z"
      fill="currentColor"
    />
  </svg>`;
};
